<div class="incoming-call-container">
  <div class="call-info">
    <div class="caller-avatar">
      <i class="material-icons">person</i>
    </div>
    <div class="caller-details">
      <p class="call-subtitle">Cuộc gọi đến từ...</p>
      <p class="caller-number" *ngIf="callingPhoneNumber$ | async as number">
        {{ number }}
      </p>
      <h3 class="caller-name" *ngIf="callingPhoneName$ | async as name">
        {{ name }}
      </h3>
      <p class="call-type" *ngIf="isVideoCall$ | async as isVideo">
        {{ isVideo ? 'Cuộc gọi video' : 'Cuộc gọi thoại' }}
      </p>
    </div>
  </div>

  <div class="call-actions">
    <button class="action-btn" (click)="openTicket()" title="Xem phiếu" *ngIf="crm_url">
      <i class="material-icons">confirmation_number</i>
    </button>
    <button class="action-btn reject-btn" (click)="rejectCall()" title="Từ chối">
      <i class="material-icons">call_end</i>
    </button>
    <button class="action-btn" [class.active]="isMuted" (click)="toggleMute()" title="Tắt tiếng">
      <i class="material-icons">{{ isMuted ? 'mic_off' : 'mic' }}</i>
    </button>
    <button class="action-btn answer-btn" (click)="answerCall()" title="Trả lời">
      <i class="material-icons">call</i>
    </button>
  </div>
</div>